import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Toast, ToastType } from '../components/Layout/Toast';

// Define the toast function type
type ToastFunction = (message: string, type?: ToastType, promiseResolve?: any) => void;

// Update the context type to be the function itself
const ToastContext = createContext<ToastFunction | undefined>(undefined);

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const [toastMessage, setToastMessage] = useState<string>('');
  const [toastType, setToastType] = useState<string>('');
  const [promiseResolveData, setPromiseResolveData] = useState<any>(null);
  const [toastKey, setToastKey] = useState(0);

  // Define the toast function that will be provided by the context
  const toast: ToastFunction = (message: string, type: ToastType = 'default', promiseResolve?: any) => {
    setToastMessage(message);
    setToastType(type);
    setPromiseResolveData(promiseResolve);
    setToastKey(prevKey => prevKey + 1);
  };

  return (
    <ToastContext.Provider value={toast}>
      <Toast message={toastMessage} type={toastType as ToastType} promiseResolve={promiseResolveData} toastKey={toastKey} />
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};